<template>
  <div class="startScreenerView">
    <div class="header">
      <div v-if="avatarDefaultIdleAnimations.length && screenerAvatar" class="avatar-container">
        <AvatarComponent
          :options="{ position: 'dynamic', size: 'height', audio: '' }"
          :inSession="false"
          :isAnimating="true"
        />
      </div>
      <h1 v-if="!demoLoading">Screener Paused</h1>
      <div v-else class="loading-transition">
        <h1>Loading...</h1>
        <font-awesome-icon :icon="faSpinner" :size="'3x'" :spin="true" class="fast-spin spinner" />
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
// Vue
import { onMounted } from 'vue'
import { storeToRefs } from 'pinia'

// FontAwesome
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'

// Components
import AvatarComponent from '@/components/AvatarComponent.vue'

// Stores
import { useEffectsStore } from '@/stores/EffectsStore'
import { useDataStore } from '@/stores/DataStore'
import { useActiveScreenerStore } from '@/stores/activeScreenerStore'

const dataStore = useDataStore()
const effectsStore = useEffectsStore()
const activeScreenerStore = useActiveScreenerStore()
const { screenerAvatar, demoLoading } = storeToRefs(dataStore)
const { avatarDefaultIdleAnimations } = storeToRefs(effectsStore)

onMounted(() => {
  activeScreenerStore.confirmAction('Paused')
})
</script>

<style lang="scss" scoped>
.loading-transition {
  display: flex;
  flex-direction: column;
  gap: 1rem;

  .spinner {
    color: $primary;
  }
}
</style>
